export default {
	methods: {
		errorToast(message, title = "Failed") {
			this.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "danger-toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
			this.toasttext = "";
		},
		successToast(message, title = "Success") {
			this.$bvToast.toast(message, {
				title: title,
				solid: true,
				autoHideDelay: 5000,
				headerClass: "toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
			this.toasttext = "";
		},
	},
};
